<div *ngIf="isClickable" [ngClass]="isClickable ? 'language-tag' : ''" class="tag-item d-flex tw-items-center" (click)="isClicked()">
  <span class="pr-2">{{ title }}</span>
  <mat-icon>edit</mat-icon>
</div>
<div *ngIf="!isClickable" class="tag-item">{{ title }}</div>
